import columns from './utils/columns.js'

const state = {
  // Layout Data
  columns,

  // UI State
  isLoading: false,
  hasError: false,
  errorMessage: null,
  selectedTab: 'profile',

  // User Settings
  userSettings: {
    profile: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      title: '',
      department: '',
    },
    preferences: {
      theme: 'light',
      language: 'en',
      timezone: 'UTC',
      dateFormat: 'MM/dd/yyyy',
      timeFormat: '12h',
    },
    notifications: {
      email: {
        enabled: true,
        digest: 'daily',
        marketing: false,
      },
      push: {
        enabled: true,
        browser: true,
        mobile: false,
      },
      alerts: {
        systemMaintenance: true,
        securityUpdates: true,
        featureUpdates: false,
      },
    },
    security: {
      twoFactorAuth: false,
      sessionTimeout: 30,
      passwordExpiry: 90,
    },
    privacy: {
      shareUsageData: false,
      allowAnalytics: true,
      shareProfileData: false,
    },
  },

  // Settings metadata
  lastUpdated: null,
  version: '1.0.0',

  // Filters and saved states
  savedFilters: [],
  customReports: [],

  // Demo mode settings
  demoMode: {
    enabled: false,
    sampleData: false,
  },

  // Alias settings
  aliasSettings: {
    active: false,
    email: null,
    permissions: [],
  },
}

export default state
